var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Import Promotion Claim"}},[_c('vs-tabs',[_c('promotion-claim')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }